import axios from './base'
const url = `/website`

export function getCompanyInfo(params = {}){
  return axios.request({
    url: `${url}/company-info`,
    method: "get",
    params,
  })
}

export function getCompanyLanguage(lang_id, params = {}){
  return axios.request({
    url: `${url}/company-info/lang/${lang_id}`,
    method: "get",
    params,
  })
}

export function updateCompanyInfo(id, data = {}){
  return axios.request({
    url: `${url}/company-info/${id}`,
    method: "put",
    data,
  })
}

export function getProcessByLang(lang_id, params = {}){
  return axios.request({
    url: `${url}/process/lang/${lang_id}`,
    method: "get",
    params,
  })
}

export function getProcess(id, params = {}){
  return axios.request({
    url: `${url}/process/${id}`,
    method: "get",
    params,
  })
}

export function addProcess(data = {}){
  return axios.request({
    url: `${url}/process`,
    method: "post",
    data,
  })
}

export function updateProcess(id, data = {}){
  return axios.request({
    url: `${url}/process/${id}`,
    method: "put",
    data,
  })
}

export function deleteProcess(id, params = {}){
  return axios.request({
    url: `${url}/process/${id}`,
    method: "delete",
    params,
  })
}

export function getCultureByLang(lang_id, params = {}){
  return axios.request({
    url: `${url}/culture/lang/${lang_id}`,
    method: "get",
    params,
  })
}

export function getCulture(id, params = {}){
  return axios.request({
    url: `${url}/culture/${id}`,
    method: "get",
    params,
  })
}

export function addCulture(data = {}){
  return axios.request({
    url: `${url}/culture`,
    method: "post",
    data,
  })
}

export function updateCulture(id, data = {}){
  return axios.request({
    url: `${url}/culture/${id}`,
    method: "put",
    data,
  })
}

export function deleteCulture(id, params = {}){
  return axios.request({
    url: `${url}/culture/${id}`,
    method: "delete",
    params,
  })
}

export function getProductCategories(params = {}){
  return axios.request({
    url: `${url}/product/categories`,
    method: "get",
    params,
  })
}

export function addProductCategory(data = {}){
  return axios.request({
    url: `${url}/product/categories`,
    method: "post",
    data,
  })
}

export function updateProductCategory(id, data = {}){
  return axios.request({
    url: `${url}/product/categories/${id}`,
    method: "put",
    data,
  })
}

export function deleteProductCategory(id, params = {}){
  return axios.request({
    url: `${url}/product/categories/${id}`,
    method: "delete",
    params,
  })
}


export function getNewsCategories(params = {}){
  return axios.request({
    url: `${url}/news/categories`,
    method: "get",
    params,
  })
}

export function addNewsCategory(data = {}){
  return axios.request({
    url: `${url}/news/categories`,
    method: "post",
    data,
  })
}

export function updateNewsCategory(id, data = {}){
  return axios.request({
    url: `${url}/news/categories/${id}`,
    method: "put",
    data,
  })
}

export function deleteNewsCategory(id, params = {}){
  return axios.request({
    url: `${url}/news/categories/${id}`,
    method: "delete",
    params,
  })
}

export function getNewsList(params = {}){
  return axios.request({
    url: `${url}/news/list`,
    method: "get",
    params,
  })
}

export function addNews(data = {}){
  return axios.request({
    url: `${url}/news`,
    method: "post",
    data,
})
}

export function updateNews(id, data = {}){
  return axios.request({
    url: `${url}/news/${id}`,
    method: "put",
    data,
})
}

export function deleteNews(id){
  return axios.request({
    url: `${url}/news/${id}`,
    method: "delete",
})
}

export function getProducts(params = {}){
  return axios.request({
    url: `${url}/products`,
    method: "get",
    params,
  })
}

export function addProduct(data = {}){
  return axios.request({
    url: `${url}/product`,
    method: "post",
    data,
  })
}

export function updateProduct(id, data = {}){
  return axios.request({
    url: `${url}/product/${id}`,
    method: "put",
    data,
  })
}

export function deleteProduct(id, params = {}){
  return axios.request({
    url: `${url}/product/${id}`,
    method: "delete",
    params,
  })
}

// ========== 解决方案 (Solutions) ==========
export function getSolutions(params = {}){
  return axios.request({
    url: `${url}/solutions`,
    method: "get",
    params,
  })
}

export function addSolution(data = {}){
  return axios.request({
    url: `${url}/solution`,
    method: "post",
    data,
  })
}

export function updateSolution(id, data = {}){
  return axios.request({
    url: `${url}/solution/${id}`,
    method: "put",
    data,
  })
}

export function deleteSolution(id, params = {}){
  return axios.request({
    url: `${url}/solution/${id}`,
    method: "delete",
    params,
  })
}

export function setSolutionHome(id, data = {}){
  return axios.request({
    url: `${url}/solution/${id}/home`,
    method: "put",
    data,
  })
}

// ========== 下载中心 (Downloads) ==========
export function getDownloads(params = {}){
  return axios.request({
    url: `${url}/downloads`,
    method: "get",
    params,
  })
}

export function addDownload(data = {}){
  return axios.request({
    url: `${url}/download`,
    method: "post",
    data,
  })
}

export function updateDownload(id, data = {}){
  return axios.request({
    url: `${url}/download/${id}`,
    method: "put",
    data,
  })
}

export function deleteDownload(id, params = {}){
  return axios.request({
    url: `${url}/download/${id}`,
    method: "delete",
    params,
  })
}

export function setDownloadHome(id, data = {}){
  return axios.request({
    url: `${url}/download/${id}/home`,
    method: "put",
    data,
  })
}

// ========== Banner 管理 ==========
export function getBanners(params = {}){
  return axios.request({
    url: `${url}/banners`,
    method: "get",
    params,
  })
}

export function addBanner(data = {}){
  return axios.request({
    url: `${url}/banner`,
    method: "post",
    data,
  })
}

export function updateBanner(id, data = {}){
  return axios.request({
    url: `${url}/banner/${id}`,
    method: "put",
    data,
  })
}

export function deleteBanner(id){
  return axios.request({
    url: `${url}/banner/${id}`,
    method: "delete",
  })
}

// ========== 制造服务 (Services) ==========
export function getServices(params = {}){
  return axios.request({
    url: `${url}/services`,
    method: "get",
    params,
  })
}

export function addService(data = {}){
  return axios.request({
    url: `${url}/service`,
    method: "post",
    data,
  })
}

export function updateService(id, data = {}){
  return axios.request({
    url: `${url}/service/${id}`,
    method: "put",
    data,
  })
}

export function deleteService(id, params = {}){
  return axios.request({
    url: `${url}/service/${id}`,
    method: "delete",
    params,
  })
}

export function setServiceHome(id, data = {}){
  return axios.request({
    url: `${url}/service/${id}/home`,
    method: "put",
    data,
  })
}

// ========== 质量保障 (Quality Guarantees) ==========
export function getQualityGuarantees(params = {}){
  return axios.request({
    url: `${url}/quality-guarantees`,
    method: "get",
    params,
  })
}

export function addQualityGuarantee(data = {}){
  return axios.request({
    url: `${url}/quality-guarantee`,
    method: "post",
    data,
  })
}

export function updateQualityGuarantee(id, data = {}){
  return axios.request({
    url: `${url}/quality-guarantee/${id}`,
    method: "put",
    data,
  })
}

export function deleteQualityGuarantee(id, params = {}){
  return axios.request({
    url: `${url}/quality-guarantee/${id}`,
    method: "delete",
    params,
  })
}

// ========== 联系分类 (Contact Categories) ==========
export function getContactCategories(params = {}){
  return axios.request({
    url: `${url}/contact-categories`,
    method: "get",
    params,
  })
}

export function addContactCategory(data = {}){
  return axios.request({
    url: `${url}/contact-category`,
    method: "post",
    data,
  })
}

export function updateContactCategory(id, data = {}){
  return axios.request({
    url: `${url}/contact-category/${id}`,
    method: "put",
    data,
  })
}

export function deleteContactCategory(id, params = {}){
  return axios.request({
    url: `${url}/contact-category/${id}`,
    method: "delete",
    params,
  })
}

// ========== 联系提交记录 (Contact Submissions) ==========
export function getContactSubmissions(params = {}){
  return axios.request({
    url: `${url}/contact-submissions`,
    method: "get",
    params,
  })
}

export function updateContactSubmission(id, data = {}){
  return axios.request({
    url: `${url}/contact-submission/${id}`,
    method: "put",
    data,
  })
}

export function deleteContactSubmission(id, params = {}){
  return axios.request({
    url: `${url}/contact-submission/${id}`,
    method: "delete",
    params,
  })
}

// ========== 企业基础设置 (Company Settings) ==========
export function getCompanySettings(params = {}){
  return axios.request({
    url: `${url}/company-settings`,
    method: "get",
    params,
  })
}

export function getCompanySettingsByLang(lang_code){
  return axios.request({
    url: `${url}/company-settings/${lang_code}`,
    method: "get",
  })
}

export function updateCompanySetting(id, data = {}){
  return axios.request({
    url: `${url}/company-setting/${id}`,
    method: "put",
    data,
  })
}

// ========== 我们的优势 (Advantages) ==========
export function getAdvantages(params = {}){
  return axios.request({
    url: `${url}/advantages`,
    method: "get",
    params,
  })
}

export function addAdvantage(data = {}){
  return axios.request({
    url: `${url}/advantage`,
    method: "post",
    data,
  })
}

export function updateAdvantage(id, data = {}){
  return axios.request({
    url: `${url}/advantage/${id}`,
    method: "put",
    data,
  })
}

export function deleteAdvantage(id){
  return axios.request({
    url: `${url}/advantage/${id}`,
    method: "delete",
  })
}

// ========== 荣誉资质 (Awards) ==========
export function getAwards(params = {}){
  return axios.request({
    url: `${url}/awards`,
    method: "get",
    params,
  })
}

export function addAward(data = {}){
  return axios.request({
    url: `${url}/award`,
    method: "post",
    data,
  })
}

export function updateAward(id, data = {}){
  return axios.request({
    url: `${url}/award/${id}`,
    method: "put",
    data,
  })
}

export function deleteAward(id){
  return axios.request({
    url: `${url}/award/${id}`,
    method: "delete",
  })
}

// ========== 访问记录 (Visit Logs) ==========
export function getVisitLogs(params = {}){
  return axios.request({
    url: `${url}/visit-logs`,
    method: "get",
    params,
  })
}

// ========== SEO设置 (SEO Settings) ==========
export function getSeoSettings(params = {}){
  return axios.request({
    url: `${url}/seo-settings`,
    method: "get",
    params,
  })
}

export function updateSeoSetting(id, data = {}){
  return axios.request({
    url: `${url}/seo-setting/${id}`,
    method: "put",
    data,
  })
}

export function regenerateSeoHtml(){
  return axios.request({
    url: `${url}/regenerate-seo-html`,
    method: "post",
  })
}



